import { connect } from 'react-redux'
import YetToSetRulesTable from '../'
import {
  createRules,
  degreeStreamMap,
  getInstituteRulesById,
  ruleOverwrite,
  setUpNewRules,
} from '../../../action'
import selectors from '../../../selectors'

const mapStateToProps = state => ({
  instituteCampusId: state.auth.instituteDetails.id,
  rulesDegreesMetrics: selectors.getRulesDegreesMetrics(state),
  ruleDegreeStreamMap: selectors.getRuleStreamMap(state),
  ruleSet: selectors.getRuleSetData(state),
})

const mapDispatchToProps = {
  setUpNewRules,
  degreeStreamMap,
  createRules,
  getInstituteRulesById,
  ruleOverwrite,
}

export default connect(mapStateToProps, mapDispatchToProps)(YetToSetRulesTable)
